(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ecom-advanture-map"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const root = document.querySelector('#ecom-adventure-map-{{ section.id }}');
  if (!root) return;

  const cities = root.querySelectorAll('[data-city]');
  if (!cities.length) return;

  const isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;

  cities.forEach(function (city) {
    const trigger = city.querySelector('[data-city-trigger]');
    const closeBtn = city.querySelector('[data-city-close]');
    if (!trigger) return;

    trigger.addEventListener('click', function (e) {
      e.preventDefault();

      const isActive = city.classList.contains('is-active');

      cities.forEach(function (c) {
        c.classList.remove('is-active');
      });

      if (!isActive) {
        city.classList.add('is-active');
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        city.classList.remove('is-active');
      });
    }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('#ecom-adventure-map-{{ section.id }}')) {
      cities.forEach(function (c) {
        c.classList.remove('is-active');
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
